(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-video-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('c-video-story')) {
    customElements.define('c-video-story', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.playButton = this.querySelector('[data-play]');
        this.pauseButton = this.querySelector('[data-pause]');
        this.errorMessage = this.querySelector('[data-error]');
        this.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return;
          if (event.target.closest('[data-play]')) this.playVideo(false);
          if (event.target.closest('[data-pause]')) this.video.pause();
        }, options);
        this.video.addEventListener('playing', () => this.syncPlayback(), options);
        this.video.addEventListener('pause', () => this.syncPlayback(), options);
        this.video.addEventListener('error', () => this.showError(this.video.error), options);
        this.syncPlayback();
        if (this.video.error) this.showError(this.video.error);
        if (this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.playVideo(true);
        }
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.video?.pause();
      }

      syncPlayback() {
        const playing = !this.video.paused && !this.video.ended;
        const focusedButton = document.activeElement;
        this.toggleAttribute('data-playing', playing);
        this.playButton.tabIndex = playing ? -1 : 0;
        this.playButton.setAttribute('aria-hidden', String(playing));
        this.pauseButton.hidden = !playing || this.dataset.controls === 'true';
        if (playing && focusedButton === this.playButton) {
          if (this.dataset.controls === 'true') this.video.focus();
          else this.pauseButton.focus({ preventScroll: true });
        } else if (!playing && focusedButton === this.pauseButton) {
          this.playButton.focus({ preventScroll: true });
        }
        if (playing) this.errorMessage.hidden = true;
      }

      async playVideo(autoplay) {
        try {
          await this.video.play();
        } catch (error) {
          if (!this.isConnected || error.name === 'AbortError') return;
          this.syncPlayback();
          // Browser autoplay restrictions are expected; leave the play button available.
          if (autoplay && error.name === 'NotAllowedError') return;
          this.showError(error);
        }
      }

      showError(error) {
        console.error('[C Video Story] Video playback failed:', error);
        this.errorMessage.hidden = false;
        this.video.controls = true;
        this.syncPlayback();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-west-africa-stats"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('c-west-africa-counters')) {
    customElements.define('c-west-africa-counters', class extends HTMLElement {
      connectedCallback() {
        this.initializationFrame = requestAnimationFrame(() => {
          this.initializationFrame = null;
          this.initialize();
        });
      }

      initialize() {
        this.counters = [...this.querySelectorAll('[data-counter]')];
        this.frames = new Map();
        this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'en');
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onMotionChange = () => {
          if (this.motionPreference.matches) this.finish();
        };
        this.motionPreference.addEventListener('change', this.onMotionChange);

        this.counters.forEach((counter) => {
          counter.dataset.final = this.formatter.format(Number(counter.dataset.counter));
          this.render(counter, Number(counter.dataset.counter));
        });

        if (this.dataset.animate !== 'true' || this.motionPreference.matches || !('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.observer.unobserve(entry.target);
            this.animate(entry.target);
          });
        }, { threshold: 0.25 });
        this.counters.forEach((counter) => this.observer.observe(counter));
      }

      render(counter, value) {
        counter.querySelector('.c-west-africa-stats__value').textContent = this.formatter.format(value);
      }

      animate(counter) {
        const target = Number(counter.dataset.counter);
        const duration = Number(this.dataset.duration);
        let start;
        this.render(counter, 0);
        const tick = (time) => {
          if (start === undefined) start = time;
          const progress = Math.min((time - start) / duration, 1);
          this.render(counter, progress === 1 ? target : Math.floor(target * (1 - Math.pow(1 - progress, 3))));
          if (progress < 1) {
            this.frames.set(counter, requestAnimationFrame(tick));
          } else {
            this.frames.delete(counter);
          }
        };
        this.frames.set(counter, requestAnimationFrame(tick));
      }

      finish() {
        this.observer?.disconnect();
        this.frames.forEach((frame) => cancelAnimationFrame(frame));
        this.frames.clear();
        this.counters.forEach((counter) => this.render(counter, Number(counter.dataset.counter)));
      }

      disconnectedCallback() {
        if (this.initializationFrame !== null) cancelAnimationFrame(this.initializationFrame);
        if (this.motionPreference) {
          this.finish();
          this.motionPreference.removeEventListener('change', this.onMotionChange);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.classList.remove('color-background-3');
		this.header.style.transition = 'background var(--duration-short), transform var(--duration-default)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
		if (this.header.classList.contains('color-background-1')) {
		this.header.classList.add('color-background-3');
		};
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden','color-background-3');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.header.classList.contains('color-background-1')) {
			this.header.classList.add('color-background-3');
		};
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
